import {SOPutDatafeed} from '../../core/datafeed/so-put-datafeed';
import {DatafeedCore} from './datafeed.core';
import {SOGetDatafeed} from '../../core/datafeed/so-get-datafeed';
import {FormField, SelectionOption} from 'lionheartland';
import {putDatafeedFormFieldOptions} from './put-datafeed-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';

export class RAPutDatafeed extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putDatafeedFormFieldOptions);

  RequestClass = SOPutDatafeed

  constructor(
    public entityCore: DatafeedCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}